<template>
	<!-- 订单列表 -->
	<cell v-if="workType == 1">
		<!--产品金额-->
		<template #product_money="{data}">
			￥{{data.product_money}}
		</template>
		
		<!--订单状态-->
		<template #order_state="{data}">
			<c-state dict="salesOrderStateDic" :value="data.order_state"></c-state>
		</template>
		
		<!--排产状态-->
		<template #scheduling_state="{data}">
			<c-state dict="schedulingStateDic" :value="data.scheduling_state"></c-state>
		</template>
		
		<!--库存占用状态-->
		<template #occ_state="{data}">
			<template v-if="data.order_state == 2">
				<c-state dict="occStatedic" :value="data.occ_state"></c-state>
			</template>
			<span v-else>-</span>
		</template>
		
		<!--交货进度%-->
		<template #deliver_progress="{data}">
			<c-progress :rate="[data.deliver_count, data.main_product_count]" :color="((data.deliver_count/data.main_product_count)>=1||data.deliver_count==0) ?'green':'blue'"></c-progress>
		</template>
		
		<!--逾期状态-->
		<template #plan_date_state="{data}">
			<c-state type="expectedDate" :value="data.expected_date"></c-state>
		</template>
		
		<!--生产进度%-->
		<template #work_detail_progress="{data}">
			<c-progress v-if="data.scheduling_state == 1" :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
			<span v-else>-</span>
		</template>
	</cell>
	
	<!-- 生产计划 -->
	<cell v-else-if="workType == 2">
		<!--计划状态-->
		<template #plan_state="{data}">
			<c-state dict="salesOrderStateDic" :value="data.plan_state"></c-state>
		</template>
		
		<!--排产进度%-->
		<template #scheduling_progress="{data}">
			<c-progress :rate="[data.scheduling_count, data.plan_count]" :color="((data.scheduling_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
		</template>
		
		<!--生产进度%-->
		<template #plan_progress="{data}">
			<c-progress :rate="[data.scheduling_ok_count, data.plan_count]" :color="((data.scheduling_ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
		</template>
	</cell>
	
	<!-- 装配工单 -->
	<cell v-else-if="workType == 34">
		<!--单据状态-->
		<template #order_state="{data}">
			<c-state dict="orderStateDic" :value="data.order_state"></c-state>
		</template>
		
		<!--生产进度%-->
		<template #work_progress="{data}">
			<c-progress :rate="[data.ok_count, data.plan_count]" :color="((data.ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
		</template>
	
		<!--单据进度%-->
		<template #order_progress="{data}">
			<c-progress :rate="[data.work_end_count, data.work_all_count]" :color="((data.work_end_count/data.work_all_count)>=1||data.work_all_count==0) ?'green':'blue'"></c-progress>
		</template>
	</cell>
	
	<!-- 工单列表 -->
	<cell v-else-if="workType == 3">
		<!--产品来源-->
		<template #product_source="{data}">
			<c-state dict="productSourceName" :value="data.product_source"></c-state>
		</template>
		
		<!--产品类型-->
		<template #product_type="{data}">
			<c-state dict="productTypeName" :value="data.product_type"></c-state>
		</template>

		<!--工单进度-->
		<template #process_rate="{data}">
			<div :style="{'height': `${64 * processRateScale}px`}">
				<process-rate
					:key="data._timestamp"
					:id="data.id"
					:detail="false"
					style="transform-origin: left top;"
					:style="{'width': `${1 / processRateScale * 100}%`, 'height': `${64 * processRateScale}px`, 'transform': `scale(${processRateScale})`}"
				></process-rate>
			</div>
		</template>

		<!--工单进度%-->
		<template #work_progress="{data}">
			<c-progress :rate="[data.ok_count, data.plan_count]" :color="((data.ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
		</template>
		
		<!--工单明细进度%-->
		<template #work_detail_progress="{data}">
			<c-progress :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
		</template>

		<!--工单状态-->
		<template #work_state="{data}">
			<c-state dict="orderStateDic" :value="data.work_state"></c-state>
		</template>

		<!--优先级-->
		<template #priority="{data}">
			<c-state dict="priorityDic" :value="data.priority"></c-state>
		</template>

		<!--工期状态-->
		<template #plan_date_state="{data}">
			<c-state type="expectedDate" :value="data.expected_date"></c-state>
		</template>
	</cell>

	<!-- 任务列表 -->
	<cell v-else-if="workType == 13">
		 <!--产品来源-->
		 <template #product_source="{data}">
		 	<c-state dict="productSourceName" :value="data.product_source"></c-state>
		 </template>
		 
		<!--产品类型-->
		<template #product_type="{data}">
			<c-state dict="productTypeName" :value="data.product_type"></c-state>
		</template>

		<!--任务状态-->
		<template #state="{data}">
			<c-state dict="orderStateDic" :value="data.state"></c-state>
		</template>
		
		<!--逾期状态-->
		<template #plan_date_state="{data}">
			<c-state type="expectedDate" :value="data.expected_date"></c-state>
		</template>
		
		<!--优先级-->
		<template #priority="{data}">
			<c-state dict="priorityDic" :value="data.priority"></c-state>
		</template>
		
		<!--报工权限 -->
		<template #output_auth_names="{data}">
			<span v-if="!data.output_auth_names" >-</span>
			<c-tags v-else :value="data.output_auth_names"></c-tags>
		</template>
		
		<!--最终报工权限(综合报工权限、分配报工权限，并考虑分配是否优先) -->
		<template #all_output_auth_names="{data}">
			<span v-if="!data.all_output_auth_names" >-</span>
			<c-tags v-else :value="data.all_output_auth_names"></c-tags>
		</template>
		
		<!--任务分配 -->
		<template #output_distribute_auth_names="{data}">
			<c-tags v-if="data.output_distribute_auth_names" :value="data.output_distribute_auth_names"></c-tags>
		</template>
		
		<!--工单状态-->
		<template #work_state="{data}">
			<c-state dict="orderStateDic" :value="data.work_state"></c-state>
		</template>
		
		<!--任务进度%-->
		<template #task_progress="{data}">
			<c-progress :rate="[data.fine_count, data.plan_count]" :color="((data.fine_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
		</template>
					
		<!--加工类型-->
		<template #process_type="{data}">
			<c-state dict="processTypeDic" :value="data.process_type"></c-state>
		</template>
		
		<!--检验方式-->
		<template #test_mode="{data}">
			<c-state dict="testModeDic" :value="data.test_mode"></c-state>
		</template>

		<!--自动出库-->
		<template #material_auto_out="{data}">
			<c-state dict="openCloseDic" :value="data.material_auto_out"></c-state>
		</template>

		<!--自动入库-->
		<template #product_auto_in="{data}">
			<c-state dict="openCloseDic" :value="data.product_auto_in"></c-state>
		</template>

		<!--报工前打卡（0：不开启，1：开启）-->
		<template #output_start="{data}">
			<c-state dict="openCloseDic" :value="data.output_start"></c-state>
		</template>
	</cell>
	 
	<!-- 报工记录 -->
	<cell v-else-if="workType == 14">
	 	<!--报工类型-->
	 	<template #output_type="{data}">
	 		<c-state dict="outputTypeDic" :value="data.output_type"></c-state>
	 	</template>
	 	
	 	<!--报工良品率-->
	 	<template #fine_ratio="{data}">
	 		{{data.fine_ratio}}%
	 	</template>
	 	
	 	<!--检验方式-->
	 	<template #test_mode="{data}">
	 		<c-state dict="testModeDic" :value="data.test_mode"></c-state>
	 	</template>
	 	
	 	<!--检验状态-->
	 	<template #test_state="{data}">
	 		<c-state dict="testStateDic" :value="data.test_state"></c-state>
	 	</template>
	 	
	 	<!--质检人-->
	 	<template #test_user_realname="{data}">
	 		<span v-if="data.test_state == 3">{{data.test_user_realname}}</span>
	 		<span v-else>-</span>
	 	</template>
	 	
	 	<!--质检时间-->
	 	<template #test_date="{data}">
	 		<span v-if="data.test_state == 3">{{data.test_date}}</span>
	 		<span v-else>-</span>
	 	</template>
	 	
	 	<!--质检数-->
	 	<template #test_count="{data}">
	 		<span v-if="data.test_state == 3">{{data.test_count}}</span>
	 		<span v-else>-</span>
	 	</template>
	 	
	 	<!--质检合格数-->
	 	<template #test_fine_count="{data}">
	 		<span v-if="data.test_state == 3">{{data.test_fine_count}}</span>
	 		<span v-else>-</span>
	 	</template>
	 	
	 	<!--质检不合格数-->
	 	<template #test_defects_count="{data}">
	 		<span v-if="data.test_state == 3">{{data.test_defects_count}}</span>
	 		<span v-else>-</span>
	 	</template>
	 	
	 	<!--质检良品率-->
	 	<template #test_fine_ratio="{data}">
	 		<span v-if="data.test_state == 3">{{data.test_fine_ratio}}%</span>
	 		<span v-else>-</span>
	 	</template>
	 	
	 	<!--计价方式-->
	 	<template #pricing_type="{data}">
	 		<c-state dict="pricingTypeDic" :value="data.pricing_type"></c-state>
	 	</template>
	 	
	 	<!--预计工资-->
	 	<template #pre_salary="{data}">
	 		{{parseFloat(data.pre_salary).toFixed(2)}}
	 	</template>
	 	
	 	<!--产品来源-->
	 	<template #product_source="{data}">
	 		<c-state dict="productSourceName" :value="data.product_source"></c-state>
	 	</template>
	 	
	 	<!--产品类型-->
	 	<template #product_type="{data}">
	 		<c-state dict="productTypeName" :value="data.product_type"></c-state>
	 	</template>
	 	
	 	<!--工单状态-->
	 	<template #work_state="{data}">
	 		<c-state dict="orderStateDic" :value="data.work_state"></c-state>
	 	</template>
	 	
	 	<!--任务状态-->
	 	<template #task_state="{data}">
	 		<c-state dict="orderStateDic" :value="data.task_state"></c-state>
	 	</template>
	 	
	 	<!--审批状态-->
	 	<template #state="{data}">
	 		<c-state dict="auditStateDic" :value="data.state"></c-state>
	 	</template>
	</cell>

	<!-- 库存收发明细列表 -->
	<cell v-else-if="workType == 16">
		<!--单据类型-->
		<template #order_type="{data}">
			<c-state dict="orderTypeName" :value="data.order_type"></c-state>
		</template>

		<!--库存类型-->
		<template #order_classify="{data}">
			<c-state dict="stockClassifyName" :value="data.order_classify"></c-state>
		</template>

		<!--库存类型-->
		<template #stock_change_count="{data}">
			<strong v-if="data.stock_change_count && data.stock_change_count > 0" style="color: green">{{data.stock_change_count}}</strong>
			<strong v-else-if="data.stock_change_count && data.stock_change_count < 0" style="color: red">{{data.stock_change_count}}</strong>
			<span v-else>{{data.stock_change_count}}</span>
		</template>

		<!--备注-->
		<template #remark="{data}">
			<span v-if="data.remark">{{data.remark}}</span>
			<span v-else>-</span>
		</template>
	</cell>
	
	<!-- 订单明细列表 -->
	<cell v-else-if="workType == 41">
		<!--完成时间-->
		<template #finish_date="{data}">
			<span v-if="data.order_state == 3">{{data.finish_date}}</span>
			<span v-else>-</span>
		</template>
		
		<!--产品单价-->
		<template #product_price="{data}">
			￥{{data.product_price}}
		</template>
		
		<!--产品金额-->
		<template #product_money="{data}">
			￥{{data.product_money}}
		</template>
		
		<!--产品来源-->
		<template #product_source="{data}">
			<c-state dict="productSourceName" :value="data.product_source"></c-state>
		</template>
		
		<!--产品类型-->
		<template #product_type="{data}">
			<c-state dict="productTypeName" :value="data.product_type"></c-state>
		</template>
		
		<!--订单状态-->
		<template #order_state="{data}">
			<c-state dict="salesOrderStateDic" :value="data.order_state"></c-state>
		</template>
		
		<!--交货进度%-->
		<template #deliver_progress="{data}">
			<c-progress :rate="[data.deliver_count, data.main_product_count]" :color="((data.deliver_count/data.main_product_count)>=1||data.deliver_count==0) ?'green':'blue'"></c-progress>
		</template>
		
		<!--逾期状态-->
		<template #plan_date_state="{data}">
			<c-state type="expectedDate" :value="data.expected_date"></c-state>
		</template>
		
		<!--生产进度%-->
		<template #work_detail_progress="{data}">
			<c-progress v-if="data.scheduling_count > 0" :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
			<span v-else>-</span>
		</template>
	</cell>

	<!-- 库存余额列表 -->
	<cell v-else-if="workType == 17">
		<!--库存状态-->
		<template #stock_state="{data}">
			<c-state dict="stockStateName" :value="data.stock_state"></c-state>
		</template>
		
		<!--库存数量-->
		<template #product_count="{data}">
			<strong v-if="data.product_count && data.product_count > 0" style="color: green">{{data.product_count}}</strong>
			<strong v-else-if="data.product_count && data.product_count < 0" style="color: red">{{data.product_count}}</strong>
			<span v-else>{{data.product_count}}</span>
		</template>
	</cell>

	<!-- 员工绩效列表 -->
	<cell v-else-if="workType == 61">
		<!--部门-->
		<template #department_names="{data}">
			<span v-if="!data.department_names">-</span>
			<c-tags v-else :value="data.department_names"></c-tags>
		</template>
		
		<!--角色-->
		<template #role_names="{data}">
			<span v-if="!data.role_names">-</span>
			<c-tags v-else :value="data.role_names"></c-tags>
		</template>
	</cell>

	<!-- 生产报表列表 -->
	<cell v-else-if="workType == 67">
		<!--工单状态-->
		<template #work_state="{data}">
			<c-state dict="orderStateDic" :value="data.work_state"></c-state>
		</template>

		<!--任务状态-->
		<template #task_state="{data}">
			<c-state dict="orderStateDic" :value="data.task_state"></c-state>
		</template>

		<!--计价方式-->
		<template #pricing_type="{data}">
			<c-state dict="pricingTypeDic" :value="data.pricing_type"></c-state>
		</template>

		<!--报工审批状态-->
		<template #output_state="{data}">
			<c-state dict="auditStateDic" :value="data.output_state"></c-state>
		</template>
	</cell>

	<!-- 不良品项目明细 -->
	<cell v-else-if="workType == 38"></cell>
	<!-- 任务数据汇总 -->
	<cell v-else-if="workType == 82">
		<template #defects_count="{data}">
			<font color="red">{{data.defects_count}}</font>
		</template>
	</cell>

</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library'

	const cell = {
		render(h) {
			return (
				<span>
					{
						this.$scopedSlots[this.$parent.name]
							? this.$scopedSlots[this.$parent.name]({data: this.$parent.data})
							: this.$parent.media
								? <c-file-list value={this.$parent.cellData} size="mini"></c-file-list>
								: typeof this.$parent.cellData == 'object'
									? [
										<c-tags value={this.$parent.cellData}></c-tags>
									]
									: this.$parent.cellData
					}
				</span>
			)
		}
	}

	export default {
		components: {
			cell
		},

		props: {
			workType: [String, Number],
			name: String,
			data: Object,
			customConfig: Object
		},

		data() {
			return {
				...getStore(this, 'digitalStore')
			}
		},

		computed: {
			...mapStore('digitalStore', ['processRateScale']),

			cellData() {
				return this.customConfig
					? this.data.customFieldValues[this.name].display_value || this.data.custom_fields_value_json[this.name]
					: this.data[this.name];
			},

			media() {
				return this.customConfig ? ['file', 'image'].includes(this.customConfig.type) : false;
			}
		}
	}
</script>